__turbopack_context__.v({
  "active": "footer-module-scss-module__w82FhG__active",
  "address": "footer-module-scss-module__w82FhG__address",
  "addressWrapper": "footer-module-scss-module__w82FhG__addressWrapper",
  "footer": "footer-module-scss-module__w82FhG__footer",
  "footerContent": "footer-module-scss-module__w82FhG__footerContent",
  "heart": "footer-module-scss-module__w82FhG__heart",
  "jsLove": "footer-module-scss-module__w82FhG__jsLove",
  "languageButton": "footer-module-scss-module__w82FhG__languageButton",
  "languageSelector": "footer-module-scss-module__w82FhG__languageSelector",
  "menu": "footer-module-scss-module__w82FhG__menu",
  "menuWrapper": "footer-module-scss-module__w82FhG__menuWrapper",
  "privacy": "footer-module-scss-module__w82FhG__privacy",
  "socials": "footer-module-scss-module__w82FhG__socials",
});
